import { Button, Form, Input, Space } from "antd";

import { useStore } from "../../config/store";

export const RefuseBlock = () => {
  const [form] = Form.useForm();
  const { changeClean, cancelDrawer } = useStore();

  const submitHandler = async (values: any) => {
    await changeClean({ status: "refusal", refuse_reason: values.refuse_reason });
    cancelDrawer();
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Form
        form={form}
        onFinish={submitHandler}
        layout="vertical"
        autoComplete="off"
      >
        <Form.Item
          name="refuse_reason"
          label="Напишите причину"
          rules={[{ required: true, message: "Необходимо указать причину отказа" }]}
        >
          <Input.TextArea
            autoSize={{ minRows: 5 }}
          />
        </Form.Item>

        <Button block size="large" color="danger" variant="outlined" htmlType="submit">
          Отказаться
        </Button>

      </Form>
      <Button onClick={cancelDrawer} block size="large">
        Закрыть
      </Button>
    </Space>
  );
};
